:host {
  * {
    box-sizing: border-box;
    &:focus {
      outline: none;
    }
  }

  .faq-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    margin-bottom: 20px;
    cursor: pointer;
    background: white;
    background: var(--bg-primary);
    padding: 20px 30px;
    border-radius: 8px 10px 10px 8px;

    .faq-item-title {
      &__text {
        width: 100%;
        display: block;
        font-weight: 400;
        color: #333333;
        color: var(--font-primary);
        font-size: 20px;
        text-decoration: none;
      }
    }

    .faq-item-legend {
      display: flex;

      &__like {
        font-size: 12px;
        margin-top: 10px;
        display: flex;
        align-items: center;
        color: rgb(255, 255, 255);
        width: auto;
        background: rgb(0, 152, 255);
        padding: 1px 8px 1px 5px;
        border-radius: 4px;

        img {
          width: 12px;
          margin-right: 10px;
          margin-left: 5px;
          filter: invert(100%) sepia(0%) saturate(7483%) hue-rotate(131deg) brightness(100%)
            contrast(105%);
          filter: var(--icon-white);
        }
      }

      &__date {
        display: flex;
        align-items: center;
        margin-top: 10px;
        margin-left: 10px;
      }
    }

    .faq-item-goTo {
      img {
        margin-left: 15px;
        width: 15px;
        height: 15px;
        filter: invert(54%) sepia(44%) saturate(7155%) hue-rotate(183deg) brightness(102%)
          contrast(109%);
        filter: var(--icon-blue);
      }
    }
  }

  /* -------------------------------------------------------------------------- */
  /*                                FULL VERSION                                */
  /* -------------------------------------------------------------------------- */
  .faq-item--full {
    scrollbar-width: none; /* For Firefox */
    -ms-overflow-style: none; /* For Internet Explorer and Edge */

    &::-webkit-scrollbar {
      width: 0px; /* For Chrome, Safari, and Opera */
    }
  }
}
